import EvProgressDialog from '../components/EvProgressDialog';
import { mountComponent } from './componentMount';

async function execute(items, method) {
  if (!Array.isArray(items)) {
    throw new TypeError('데이터는 배열로 와야 합니다.');
  }

  if (typeof method !== 'function') {
    throw new TypeError('적절한 함수가 아닙니다.');
  }

  let mountedComponent;
  mountedComponent = mountComponent(EvProgressDialog, {
    items,
    method,
    onDone: () => mountedComponent.unmount()
  });

  return mountedComponent.component.run();
}

export default {
  install(app) {
    app.config.globalProperties.$progress = execute;
  }
};
